import { useUserAccess } from '@/hooks/useUserAccess';
import { useUser } from '@/hooks/useUser';

/**
 * Hook that determines whether to show the mobile top bar notification
 */
export function useHasMobileTopbarMessage() {
  const { data: userData, queryStatus: userFetchStatus } = useUser();
  const { data: userAccess, status: userAccessFetchStatus } = useUserAccess();

  if (userFetchStatus !== 'success' || userAccessFetchStatus !== 'success') {
    return false;
  }

  if (!userData.loggedIn) {
    return false;
  }

  /**
   * A '-1' value means unlimited company report views.
   * We can assume that the user has a paid subscription.
   */
  if (
    userAccess.viewCompanyReports === -1 &&
    userData.billing.status !== 'trialing'
  ) {
    return false;
  }

  return true;
}
